import { createSlice } from "@reduxjs/toolkit";

function padTo2Digits(num) {
  return num.toString().padStart(2, "0");
}

function formatDate(date) {
  return [date.getFullYear(), padTo2Digits(date.getMonth() + 1), padTo2Digits(date.getDate())].join("-");
}

const initialState = {
  data: {
    schedulebdata: {
      countryofexport: "US",
      hscode: "",
      date: formatDate(new Date()),
      language: "EN",
    },
    submitbutton: false,
    schedulebresults: [],
  },
};

const scheduleBSlice = createSlice({
  name: "schedulebdata",
  initialState,
  reducers: {
    storeScheduleBData(state, action) {
      switch (action.payload.type) {
        case "country":
          state.data.schedulebdata.countryofexport = action.payload.selectedvalue;
          break;

        case "hscode":
          state.data.schedulebdata.hscode = action.payload;
          break;

        case "date":
          state.data.schedulebdata.date = action.payload;
          break;

        case "language":
          state.data.schedulebdata.language = action.payload;
          break;

        default:
          break;
      }
    },
    captureButtonClickScheduleB(state, action) {
      state.data.submitbutton = action.payload;
    },

    storeScheduleBResults(state, action) {
      state.data.schedulebresults = action.payload;
    },
  },
});

export const { storeScheduleBData, captureButtonClickScheduleB, storeScheduleBResults } = scheduleBSlice.actions;

export default scheduleBSlice.reducer;
